<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.qualityItem.details')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/qualityItem">
              <span>{{$t('tlt.qualityItem.list')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
             <router-link :to="{path:'/prd/qualityItemDetails', query:{id: qualityItemStatus.id}}">
              <span>{{$t('tlt.qualityItem.details')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button class="btn btn-primary" type="button" v-on:click="MMFbackToList('qualityItem')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.qualityItemDetails.back')}}</span>
          </button>
        </div>
      </div>
    </div>

    <section class="app-content">
      <div class="card">
        <div class="card-header">
          <h4>检验项目信息</h4>
        </div>
        <div class="card-body">
          <form>
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityItemCode')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityItemStatus.itemCode"
                />
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityItemName')}}:</label>
                <input
                  class="form-control"
                  type="text"
                  disabled="disabled"
                  v-model="qualityItemStatus.itemName"
                />
              </div>

              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityItemCraftType')}}:</label>
                <select
                  class="form-control"
                  disabled="disabled"
                  v-model="qualityItemStatus.craftType"
                >
                  <option value>{{ $t("lbl.basic.select.one") }}</option>
                  <option value="p">{{$t("lbl.qualityItem.pelletizing")}}</option>
                  <option value="s">{{$t("lbl.qualityItem.smelt")}}</option>
                </select>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">{{$t('lbl.qualityItemCheckType')}}:</label>
                <select
                  class="form-control"
                  disabled="disabled"
                  v-model="qualityItemStatus.checkType"
                >
                  <option value>{{ $t("lbl.basic.select.one") }}</option>
                  <option value="material">{{$t("lbl.qualityItem.material")}}</option>
                  <option value="process">{{$t("lbl.qualityItem.process")}}</option>
                  <option value="production">{{$t("lbl.qualityItem.production")}}</option>
                </select>
              </div>
              <div class="col-lg-12 align-self-end">
                <div class="float-lg-right">
                  <button class="btn btn-primary" type="button" @click="toggle">
                    <i class="fa fa-fw fa-lg fa-save"></i>
                    <span class="text">{{$t("btn.basic.newPara")}}</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="card my-1">
        <div class="card-body" v-show="flog">
          <h4>{{$t('tlt.qualityItemDetails.new')}}</h4>
          <div class="row">
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualityItemDetails.parameterCode')}}:
              </label>
              <!--可以改为dimsearch-->
              <dimsearch
                validate="required"
                name="parameterCode"
                v-model="parameterId"
                :entity="parameters"
                bindId="parameter"
                bindProp="code"
                submitProp="id"
              ></dimsearch>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualityItemDetails.parameterName')}}:
              </label>
              <!--可以改为dimsearch-->
              <dimsearch
                validate="required"
                name="parameterName"
                v-model="parameterId"
                :entity="parameters"
                bindId="parameter"
                bindProp="name"
                submitProp="id"
              ></dimsearch>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualityItemDetails.parameterUnit')}}:
              </label>
              <!--可以改为dimsearch-->
              <dimsearch
                validate="required"
                name="parameterUnit"
                v-model="parameterId"
                :entity="parameters"
                bindId="parameter"
                bindProp="unit"
                submitProp="id"
              ></dimsearch>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualityItemDetails.measureUp')}}:
              </label>
              <dimsearch
                validate="required"
                name="parameterUnit"
                v-model="parameterId"
                :entity="parameters"
                bindId="parameter"
                bindProp="lowLimit"
                submitProp="id"
              ></dimsearch>
            </div>
            <div class="form-group col-md-2">
              <label class="control-label">
                <span class="lbl-obg">*</span>
                {{$t('lbl.qualityItemDetails.measureDown')}}:
              </label>
              <dimsearch
                validate="required"
                name="parameterUnit"
                v-model="parameterId"
                :entity="parameters"
                bindId="parameter"
                bindProp="upLimit"
                submitProp="id"
              ></dimsearch>
            </div>
            <div class="col-lg-12 align-self-end">
              <div class="float-lg-right">
                <button
                  class="btn btn-primary"
                  type="button"
                  v-on:click="QualityItemSave('qualityItemDetails')"
                >
                  <i class="fa fa-fw fa-lg fa-save"></i>
                  <span class="text">{{$t('btn.basic.save')}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="qualityItemResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table
                entity="qualityItemDetails"
                inline-actions-disabled
                :singleChoice="false"
                disableDelete
              >
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <button
                    v-b-modal.modal-1
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength ==0"
                    v-bind:class="'btn btn-outline-primary btn-sm'"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                    <span class="text">{{ $t("btn.basic.delete") }}</span>
                  </button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" centered title="确认删除" @ok="Delete('qualityItemDetails')">
      <div class="d-block text-center">
        <h3>确认删除？</h3>
      </div>
    </b-modal>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import MmfTable from "@/components/MmfTable";
import dimsearch from "@/components/MMFDimSearch";
import { fields } from "@/model/prd/qualityMgt/qualityItemConfig/QualityItemDetails";
// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityItemDetails/getField",
  mutationType: "qualityItemDetails/updateField"
});

export default {
  name: "qualityItemDetailsList",

  data() {
    return {
      parameters: [],
      flog: false
    };
  },
  components: { MmfTable, dimsearch },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(fields),
    ...mapState({
      rows: state => state.qualityItemDetails.rows,
      entity: state => state.qualityItemDetails.entity,
      qualityItemStatus: state => state.qualityItemDetails.qualityItemStatus,
      baseModuleUrl : state => state.qualityItemDetails.baseModuleUrl
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFClearFilter"]),
    ...mapActions("qualityItemDetails", ["Save", "Delete"]),

    toggle: function() {
      this.flog = !this.flog;
    },

    clearAllFilter(entity) {
      this.$store.commit(entity + "/" + "setNewEntity", {}, { root: true });
      this.clearDimSearch();
      this.rows = [];
    },
    clearDimSearch() {
      this.$store.dispatch(
        "dimSearch/initBind",
        {
          parameter: {}
        },
        { root: true }
      );
    },
    QualityItemSave(module) {
      this.Save(module).then(() => {
        this.clearAllFilter(module);
      });
    }
  },
  created() {
    this.$store
      .dispatch(
        "api/get",
        {
          url:
            this.$store.state.qualityItem.baseModuleUrl +
            "/qualitySpecification/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        this.parameters = data;
      });
    this.clearAllFilter("qualityItemDetails");

    const context = this.$store;
    const id = this.$route.query.id; // 从当前的路由中获取参数 id
    const baseModuleUrl = this.baseModuleUrl;

    context
      .dispatch("api/get", {
        url: baseModuleUrl + "/qualityItem/findById/" + id
      })
      .then(response => {
        context.commit("qualityItemDetails" + "/setRows", response.qualityItemDetails);
        context.dispatch("qualityItemDetails/qualityItemStatus", response);
      });
  }
};
</script>
